import React from 'react';
import BackImg from 'assets/png/loginbg.jpg';
import Logo from 'assets/png/LogoDark.svg';
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PublicRoutes } from 'routes/routeConstans';
import { MASTER_ENDPOINT } from 'utils/Constant';
import moment from 'moment';
import { getAllListData } from 'services/CommonServices';

const SSOLogin = () => {
  const navigate: any = useNavigate();
  
  const goToLoginForm = () =>{
     navigate(PublicRoutes.CLIENTLOGIN);
  }

  const loginUsingSSO = () =>{
    getAllListData(`${MASTER_ENDPOINT.LoginSAML}`, true)
        .then(() => {
          console.log('Login SAML Called');
        })   
  }

  const isSSOEnabled = () => {
    getAllListData(`${MASTER_ENDPOINT.IsSSOEnabled}`, true)
        .then((response: any) => {
          if(response?.data == false){
            navigate(PublicRoutes.CLIENTLOGIN,);
          }
        })       
  }

  React.useEffect(() => {
    isSSOEnabled();
  },[])
  
  React.useEffect(() => {    
    window.scrollTo(0, 0)
  }, [])

  return (
    <Grid container>
      <Grid item md={12} sm={12} xs={12}>
        <Typography
          component={'div'}
          sx={{ backgroundImage: `url(${BackImg})` }}
          className='login-banner'>
          <Typography component={'div'} className='login-box'>
            <Typography className='logo-text d-flex-a'>
              <img src={Logo} alt='People Optimization Index' />
            </Typography>
            <Typography component={'div'} style={{textAlign:'center'}}>
                <button className='modal-yes1-btn' style={{ width: 300 }} onClick={loginUsingSSO}>Login using SSO</button><br/>
                <button className='modal-yes1-btn' style={{ width: 300, marginTop: 20, marginBottom: 20 }} onClick={goToLoginForm}>Login Using User Name/Password</button>
            </Typography>
            <Typography className='copy-text'>
              ©{moment().format('YYYY')} People Optimization Index, Inc. All rights reserved.
            </Typography>
          </Typography>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default SSOLogin;